import { createElement } from "react";
import { IRouteConfig } from "../../../helpers/route-config";
import { OperationalForms } from "./OperationalForms";
import { TrainEventRecordSection } from "./TrainEventRecord/TrainEventRecordSection";
import { TrainEventRecordSectionOverview } from "./TrainEventRecord/TrainEventRecordSectionOverview";
import { TrainEventRecordSectionTrainEventRecord } from "./TrainEventRecord/TrainEventRecordSectionTrainEventRecord";

const operationalFormsPath = "/operationalforms";
export const dashboardOverview = 'overview';

// Train Event Record
const trainEventRecordSectionPath = `${operationalFormsPath}/traineventrecordsection`;
const trainEventRecordOverviewPath = `${trainEventRecordSectionPath}/traineventrecordsectionoverview`;
const trainEventRecordPath = `${trainEventRecordSectionPath}/traineventrecordform`;
const trainEventUserListFormPath = `${trainEventRecordSectionPath}/userlist`;
const trainEventAdminOverviewPath = `${trainEventRecordSectionPath}/${dashboardOverview}`;  

export const operationalFormsRoute = {
    breadCrumb: "Operational Forms",
    path: operationalFormsPath,
    element: createElement(OperationalForms),
} as IRouteConfig;

export const trainEventRecordSectionPathRoute = {
    breadCrumb: "Train Event Record",
    path: trainEventRecordSectionPath,
    element: createElement(TrainEventRecordSection)
} as IRouteConfig;

export const trainEventRecordOverviewPathRoute = {
    breadCrumb: "Overview",
    path: trainEventRecordOverviewPath,
    element: createElement(TrainEventRecordSectionOverview),
} as IRouteConfig;

export const trainEventRecordPathRoute = {
    breadCrumb: "Train Event Record Form",
    path: trainEventRecordPath,
    element: createElement(TrainEventRecordSectionTrainEventRecord),
} as IRouteConfig;

export const trainEventUsersSubmittedFormListRoute = {
    breadCrumb: "My Train Event Records",
    path: trainEventUserListFormPath,
    element: createElement(TrainEventRecordSectionTrainEventRecord),
    endTrail: true
} as IRouteConfig;


export const trainEventAdminOverviewPathRoute = {
    breadCrumb: "TrainEvent Record Dashboard",
    permission: "web.admin.gnh-exemption.exemption-request-dashboard",
    path: trainEventAdminOverviewPath,
    element: createElement(TrainEventRecordSectionTrainEventRecord),
} as IRouteConfig;